import {AuthState} from "@okta/okta-auth-js";

const buildAuthHeaders = (authState: AuthState): Record<string, string> => {
    const headers: Record<string, string> = {
        'Authorization': 'Bearer ' + authState.accessToken?.accessToken,
    };
    if (authState.idToken?.idToken) {
        headers['X-Id-Token'] = authState.idToken.idToken;
    }
    return headers;
};

export const buildHeader = (authState: AuthState) => ({
    ...buildAuthHeaders(authState),
    'Content-Type': 'application/json'
});

export const buildTextHeader = (authState: AuthState) => ({
    ...buildAuthHeaders(authState),
    'Content-Type': 'text/plain'
});

export const buildCsvHeader = (authState: AuthState) => ({
    ...buildAuthHeaders(authState),
    'Content-Type': 'text/csv'
});

export const buildFileHeader = (authState: AuthState) => ({
    ...buildAuthHeaders(authState)
});

export const buildExcelHeader = (authState: AuthState) => ({
    ...buildAuthHeaders(authState),
    'Content-Type': 'application/json'
});
